import React from 'react'
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {Link} from "react-scroll"

function TopNav() {
   

    return (
        <div id='navbar'>
            <Box sx={{ flexGrow: 1 }}>
                <Toolbar className="nav-btn">
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    </Typography>
                    <Link  activeClass="active"
                            to="about"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration= {1000}>
                    <Button id="about-btn" >About</Button>
                    </Link>
                    <Link activeClass="active"
                            to="projects"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration= {1000}>
                    <Button id="projects-btn">Projects</Button>
                    </Link>
                    <Link activeClass="active"
                            to="contact"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration= {1000}>
                    <Button id="contact-btn">Contact</Button>
                    </Link>
                </Toolbar>
      
            </Box>
        </div>
    )
}

export default TopNav
